import { useRef } from "react";
import { IStatus } from "../IWebsiteDataV3";
import { IonContent, IonItem, IonList, IonPopover } from "@ionic/react";

const statuses: IStatus[] = ['danger', 'caution', 'healthy'];

export const statusLabels: { [key in IStatus]: string } = {
    'danger': 'This year is at risk',
    'caution': 'Next year is at risk',
    'healthy': 'Healthy continuity for at least this year and next year',
}
export type IStatusType = 'volunteer' | 'funding' | 'lab';

export const statusTypeToIconMap: { [ key in IStatusType]: string } = {
    'volunteer' : 'fa-child-reaching',
    'funding' : 'fa-hand-holding-dollar',
    'lab' : 'fa-building-flag',
}

export const StatusPopoverPicker: React.FC<{ isOpen: boolean; onStatusPicked: (status: IStatus) => void; statusType: IStatusType; }> = ({ isOpen, onStatusPicked, statusType }) => {
    const popover = useRef<HTMLIonPopoverElement>(null);

    return (
        <IonPopover
            // cannot use backdrop b/c a conflicting style is causing it to not be full height
            showBackdrop={false}

            key={`${isOpen}`}
            ref={popover}
            isOpen={isOpen}
            // TODO: why do I have to specify height (likely bootstrap or some other conflicting styles)
            style={{ '--width': 400, height: '220px' }}
        >
            <IonContent class="ion-padding">
                <IonList lines="none">
                    {statuses.map(status => (
                        <IonItem key={status} button onClick={() => {
                            onStatusPicked(status);
                        }}>
                            <i className={`fa ${statusTypeToIconMap[statusType]} ${status}`} style={{ fontSize: 26, width: 40, display: 'inline-block' }} />
                            {statusLabels[status]}
                        </IonItem>
                    ))}
                </IonList>
            </IonContent>
        </IonPopover>
    )
}